'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publisherTypes = undefined;
exports.getPublisherByType = getPublisherByType;
exports.imagePublisher = imagePublisher;
exports.beaconPublisher = beaconPublisher;
exports.fetchPublisher = fetchPublisher;

var _pixel = require('../pixel/pixel');

var _pixel2 = _interopRequireDefault(_pixel);

var _tools = require('../tools/tools');

var _tools2 = _interopRequireDefault(_tools);

var _navigator = require('./navigator');

var _env = require('./env');

var _env2 = require('../env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publisherTypes = exports.publisherTypes = {
  image: 'image',
  beacon: 'beacon',
  fetch: 'fetch'
};

function getPublisherByType(type) {
  var publisher = void 0;

  switch (type) {
    case publisherTypes.beacon:
      {
        publisher = beaconPublisher;
        break;
      }
    case publisherTypes.fetch:
      {
        publisher = fetchPublisher;
        break;
      }
    case publisherTypes.image:
      {
        publisher = imagePublisher;
        break;
      }
    default:
      {
        if ((0, _env.isWebWorker)() || !(0, _env2.env)().Image) {
          publisher = fetchPublisher;
        } else {
          publisher = imagePublisher;
        }
      }
  }

  return publisher;
}

function imagePublisher(baseUrl, data) {
  // eslint-disable-line func-names
  return _pixel2.default.fetch(baseUrl + '?' + _tools2.default.mapToQuery(data));
}

function beaconPublisher(baseUrl, data) {
  // eslint-disable-line func-names
  var url = baseUrl + '?' + _tools2.default.mapToQuery(data);
  return new Promise(function (resolve, reject) {
    return (0, _navigator.sendBeacon)(url) ? resolve(url) : reject(url);
  }).catch(function () {
    return imagePublisher(baseUrl, data);
  }).catch(function () {
    return fetchPublisher(baseUrl, data);
  });
}

function fetchPublisher(baseUrl, data) {
  // eslint-disable-line func-names
  return fetch(baseUrl + '?' + _tools2.default.mapToQuery(data), { credentials: 'include', method: 'GET' }).then(function (response) {
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/publishers/publishers.js
// module id = 74
// module chunks = 0